import { Form, notification } from "antd";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EmitError } from "../../utils/EmitError";
import useLocalStorage from "../../hooks/useLocalStorage";
import { ReactInputMask } from 'react-input-mask';
import { ThemeContext } from "../../contexts/ThemeContext";
import useAuth from "../../hooks/useAuth";
import PerfilService from "../../services/http/services/PerfilService";

export default function usePerfil() {

    const refController = useRef(new AbortController());
    const { getUserId } = useLocalStorage();
    const refFormPerfil = useRef<any>(null);
    const [loadingPage, setLoadingPage] = useState(false);
    const [obrigatorioConfirm, setObrigatorioConfirm] = useState(false);
    const navigate = useNavigate();
    const [formPerfil] = Form.useForm();
    const [phone, setPhone] = useState('');
    const inputMaskRef = useRef<ReactInputMask | null>(null);
    const { theme } = useContext(ThemeContext);

    const {
        user,
    } = useAuth();

    useEffect(() => {
        return () => refController.current.abort();
    }, []);

    const validaEmail = useCallback((email: string): boolean => {
        let er = new RegExp(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);

        if (email === '' || !er.test(email)) { return false; }
        return true;

    }, []);

    const submitBotaoEditar = useCallback(() => {


        const salvarDadosEditar = async (obj: any) => {
            try {
                setLoadingPage(true);
                //Remove os caracteres especiais do telefone
                obj.phone = obj.phone.replace(/\D/g, '');

                const data = await PerfilService.putGestorUsuarioPerfil(
                    obj,
                    refController.current.signal
                );

                notification.success({
                    message: 'Sucesso',
                    description:
                        'Seus dados foram editados com sucesso!',
                });

                localStorage.setItem('@GovfacilGestor:user', JSON.stringify(
                    { user: data }
                ));


                setLoadingPage(false);
                // navigate('/institucional');

            } catch (error) {
                setLoadingPage(false);
                let msgErro: any = (error as Error);


                EmitError(error, true, 'perfil_dkwdfaiweyi')
            }
        }

        refFormPerfil.current?.validateFields()
            .then((values: any) => {

                salvarDadosEditar(values);

            })
            .catch((errorInfo: any) => {
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });
            });


    }, []);

    useEffect((): void => {
        setLoadingPage(true);
        const buscaDadosIniciais = async () => {
            try {

                refController.current = new AbortController();

                PerfilService.getGestorUsuario(
                    getUserId(),
                    refController.current.signal
                )
                    .then((data) => {
                        if (data) {
                            refFormPerfil.current.setFieldsValue({
                                name: data?.name,
                                phone: data?.phone,
                                email: data?.email,
                            });

                            setPhone(data?.phone);
                            setLoadingPage(false);

                        }
                    }).catch((error) => {
                        EmitError(error, true, "useEffect");
                    });

                // await api.get(
                //     urlContratoEntidadeUsuario + "/" + getUserId(),
                //     {
                //         headers: {
                //             Authorization: "Bearer " + getToken(),
                //         },
                //     }
                // )


            } catch (error) {
                EmitError(error, true, "useEffect");
            }
        };
        buscaDadosIniciais();
    }, []);

    return {
        refFormPerfil,
        formPerfil,
        theme,
        inputMaskRef,
        phone,
        setPhone,
        user,
        validaEmail,
        setObrigatorioConfirm,
        obrigatorioConfirm,
        submitBotaoEditar,
        loadingPage,
    }
}
